import { ReoSubscribe } from '@reolink/web.fe.shared-modules';
import React from 'react';
import styles from './index.module.less';
import '@reolink/web.fe.shared-modules/dist/style.css';
interface ISubscribeInputProps {
    /**
     * 语言包
     */
    langPack: Record<string, Record<string, string>>;
    /**
     * 订阅主题key
     */
    subject: string;
    /**
     * 输入框宽度
     */
    inputWidth?: string | number;

    /**
     * 重复订阅是否试做成功
     */
    isRepeatAsSuccess?: boolean;

    /**
     * 订阅成功回调函数
     */
    onSuccess?: () => void;

    country?: string;
}

const CompSubscribeInput: React.FC<ISubscribeInputProps> = (props) => {
    return (
        <ReoSubscribe
            langPack={ props.langPack }
            subject={ props.subject }
            country={ props.country }
            inputIconName="icon-icon_email-facet"
            iconColor="#fff"
            disabledIconColor="#fff"
            isRepeatAsSuccess={ props.isRepeatAsSuccess }
            inputWidth={ props.inputWidth ?? '' }
            wrapClassName={ styles['subscribe-input-wrapper'] }
            inputClassName={ styles['subscribe-input'] }
            iconClassName={ styles['subscribe-input-icon'] }
            submitBtnClassName={ styles['subscribe-input-btn'] }
            successClassName={ styles['subscribe-input-success'] }
            checkboxWrapClassName={ styles['subscribe-input-checkbox-wrap'] }
            // eslint-disable-next-line react/jsx-handler-names
            onSuccess={ props.onSuccess }
        />
    );
};

export default CompSubscribeInput;
